import { isUserRole, UserRoleEnum } from "../../Enums/UserRoles";

export interface UserResponseApi {
  userId: string;
  userName: string;
  userMail: string;
  userRoles: UserRoleEnum[];
}

export let isUserResponseDTO = (
  variable: unknown
): variable is UserResponseApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "userId" in variable &&
    typeof variable.userId === "string" &&
    "userName" in variable &&
    typeof variable.userName === "string" &&
    "userMail" in variable &&
    typeof variable.userMail === "string" &&
    "userRoles" in variable &&
    Array.isArray(variable.userRoles) &&
    variable.userRoles.reduce(
      (doArrayConsistOfUserRoles, userRole: unknown) =>
        doArrayConsistOfUserRoles && isUserRole(userRole),
      true
    )
  );
};

export class UserResponseImpl implements UserResponseApi {
  userId: string;
  userName: string;
  userMail: string;
  userRoles: UserRoleEnum[];

  constructor(userData: UserResponseApi) {
    this.userId = userData.userId;
    this.userName = userData.userName;
    this.userMail = userData.userMail;
    this.userRoles = userData.userRoles;
  }
}
